import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  beforeImage: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
  afterImage: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
  color: '#ff6666',
  variation: 'disc',
  backgroundColor: 'var(--color-white)',
  arrowColor: 'var(--color-primary)',
  beforeText: 'Before',
  afterText: 'After',
  width: {
    desktop: {
      unit: 'px',
      value: 400
    }
  },
  discSize: {
    desktop: 50
  } 
}
